export default __webpack_public_path__ + "assets/close_bt_white.63dafb15.svg";